<template>
    <div>
        <UiContentwrapper v-if="article">
            <UiFullcolumn v-if="mounted">
                <header class="mb-5 w-full flex justify-between">
                    <!-- Rubriken visar titeln från den aktiva slidens artikel -->
                    <div class="md:w-6/12">
                        <h2>
                            {{ article.title }}
                        </h2>
                        <div v-html="article.content">
                        </div>
                    </div>
                </header>
                <Carousel :items-to-show="itemsToShow" :items-to-scroll="1" wrap-around ref="myCarousel">
                    <template #addons>
                        <div class="paginationwrapper lg:flex; md:absolute -translate-y-full bottom-2 pb-20 right-2">

                            <div class=" lg:flex-row justify-between lg:items-start">

                                <div class="mt-2 md:mt-8 flex gap-6 justify-end ">
                                    <Navigation>
                                        <!-- Replace the default "previous" icon -->

                                        <template #prev>
                                            <Arrow />
                                        </template>
                                        <template #next>
                                            <Arrow class="rotate-180" />
                                        </template>

                                    </Navigation>
                                </div>
                            </div>
                        </div>

                    </template>
                    <Slide v-for="(article, index) in locations" :key="article.id">
                        <a target="_blank" :href="googleMapsLink(article.excerpthtml)">
                            <div class="slide-content relative pr-6">

                                <UiArticleImage v-if="article.image" :article="article" :modifiers="{
                                    auto: 'format,compress',
                                    crop: 'faces,edges',
                                    ar: '1:1'
                                }" :width="Number(914)" :height="Number(475)" sizes="341px sm:605px md:785px lg:914px">
                                    <div class="flex gap-2 items-center text-white p-2">
                                        <IconMarker />
                                        {{ article.title.split(',')[1] }}
                                    </div>
                                </UiArticleImage>

                            </div>
                        </a>
                    </Slide>

                </Carousel>

            </UiFullcolumn>
            <UiExtraNarrowColumn>
                <div class="flex justify-center flex-col items-center">
                    <NuxtLink to="/store-locator">
                        <UiRippleButton class="brown mt-12 mb-6">View all our dealers</UiRippleButton>
                    </NuxtLink>
                    <div class="flex items-center justify-center gap-4 my-8 w-full">
                        <div class="h-px flex-1 bg-gravaadarkbrown"></div>
                        <span class="text-gravaadarkbrown text-lg">or</span>
                        <div class="h-px flex-1 bg-gravaadarkbrown"></div>
                    </div>

                    <div class="text-center">

                        <UModal 
                            v-model:open="isModalOpen"
                        >
                            <h4 class="text-gravaadarkbrown underline text-xl font-semibold cursor-pointer" @click="openModal">
                                Set your preferred ride location
                            </h4>
                            <p>Want to take a test ride in your own city, town, or favorite gravel route? Let us know.
                                We'll give
                                you a heads-up as soon as we're riding near you.
                            </p>

                            <template #content="{ close }">
                                <div class="p-6 md:p-8 relative">
                                    <!-- Close button -->
                                    <button 
                                        @click="close" 
                                        class="absolute top-4 right-4 p-2 rounded-full border "
                                        aria-label="Close modal"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                    <div v-if="!formSubmitted">
                                        <h3 class="text-2xl md:text-3xl font-semibold mb-4">Let us know where you'd<br/> prefer to take your free test ride.</h3>
                                        <p class="text-gray-600 mb-6">Want to take a test ride in your own city, town, or favorite gravel route? Let us know. We'll give you a heads-up as soon as we're riding near you.</p>
                                        
                                        <form @submit.prevent="submitForm" class="space-y-4">
                                            <div>
                                                <label for="location" class="block text-sm font-semibold mb-2">Your preferred location</label>
                                                <input 
                                                    v-model="formData.location" 
                                                    type="text" 
                                                    id="location"
                                                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gravaadarkbrown"
                                                    :class="{ 'border-red-500': errors.location }"
                                                />
                                                <p v-if="errors.location" class="text-red-500 text-sm mt-1">{{ errors.location }}</p>
                                            </div>

                                            <div>
                                                <label for="country" class="block text-sm font-semibold mb-2">Country</label>
                                                <input 
                                                    v-model="formData.country" 
                                                    type="text" 
                                                    id="country"
                                                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gravaadarkbrown"
                                                    :class="{ 'border-red-500': errors.country }"
                                                />
                                                <p v-if="errors.country" class="text-red-500 text-sm mt-1">{{ errors.country }}</p>
                                            </div>

                                            <div>
                                                <label for="email" class="block text-sm font-semibold mb-2">
                                                    My E-mail address 
                                                    <span class="text-gray-400 font-normal text-xs">optional</span>
                                                </label>
                                                <input 
                                                    v-model="formData.email" 
                                                    type="email" 
                                                    id="email"
                                                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gravaadarkbrown"
                                                    :class="{ 'border-red-500': errors.email }"
                                                />
                                                <p v-if="errors.email" class="text-red-500 text-sm mt-1">{{ errors.email }}</p>
                                            </div>

                                            <div class="flex justify-end pt-4">
                                                <UiRippleButton 
                                                    type="submit" 
                                                    class="brown"
                                                    :disabled="isSubmitting"
                                                >
                                                    <span v-if="!isSubmitting" class="flex items-center gap-2">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                                                        </svg>
                                                        Send my request
                                                    </span>
                                                    <span v-else>Sending...</span>
                                                </UiRippleButton>
                                            </div>

                                            <p v-if="errors.submit" class="text-red-500 text-sm text-center">{{ errors.submit }}</p>
                                        </form>
                                    </div>

                                    <div v-else class="text-center py-8">
                                        <h3 class="text-2xl md:text-3xl font-semibold mb-4">Thanks for sharing your preferred location!</h3>
                                        <p class="text-gray-600 mb-6">Thanks for letting us know where you want to ride.<br/>As soon as we're planning something in your area, we'll send a heads-up straight to your inbox.</p>
                                        
                                        <a 
                                            href="https://www.instagram.com/gravaa_hub/" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                        >
                                            <UiRippleButton class="brown">
                                                <span class="flex items-center gap-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                                    </svg>
                                                    Follow us on Instagram
                                                </span>
                                            </UiRippleButton>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </UModal>
                        <p class="text-gravaadarkbrown mt-2">
                            Home, work, or somewhere in between — you choose,<br />
                            we'll make it happen (or give it our best shot)
                        </p>
                    </div>
                </div>
                
            </UiExtraNarrowColumn>
        </UiContentwrapper>
    </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue';
import { useBlogStore } from '@/stores/blogStore';
import { useWindowSize } from '@vueuse/core'

const { width } = useWindowSize()

const isMobile = computed(() => width.value < 800)

const blogStore = useBlogStore();
const mounted = ref(false);
const myCarousel = ref(null);
var locationsBlog = ref(null);

// Modal and form state
const isModalOpen = ref(false);
const formSubmitted = ref(false);
const isSubmitting = ref(false);

// Delay for form reset after modal closes (allows for close animation)
const MODAL_CLOSE_DELAY_MS = 300;

const formData = reactive({
    location: '',
    country: '',
    email: ''
});

const errors = reactive({
    location: '',
    country: '',
    email: '',
    submit: ''
});

// Function to clear form data and errors
const clearFormData = () => {
    formData.location = '';
    formData.country = '';
    formData.email = '';
    errors.location = '';
    errors.country = '';
    errors.email = '';
    errors.submit = '';
};

// Function to open modal and reset form state
const openModal = () => {
    isModalOpen.value = true;
    // Reset form state when opening (if previously submitted)
    if (formSubmitted.value) {
        resetForm();
    }
};

// Function to fully reset form (including submitted state)
const resetForm = () => {
    formSubmitted.value = false;
    clearFormData();
};

// Watch for modal closing and reset form
watch(isModalOpen, (newValue, oldValue) => {
    if (oldValue === true && newValue === false) {
        // Modal just closed, reset form after a delay to allow for close animation
        setTimeout(() => {
            resetForm();
        }, MODAL_CLOSE_DELAY_MS);
    }
});

// Definiera props
const props = defineProps({
    slug: {
        type: String,
        default: 'store-locator'
    },
    article: {
        type: Object,
        default: null
    }
});

const itemsToShow = computed(() => {
    return isMobile.value ? 1.5 : 5.5;
});

const googleMapsLink = (excerpthtml) => {

    try {
        if (!excerpthtml) return '';
        const parser = new DOMParser();
        const doc = parser.parseFromString(excerpthtml, 'text/html');
        const anchors = Array.from(doc.querySelectorAll('a[href]'));
        const mapRegex = /google\.com\/maps|maps\.google|goo\.gl\/maps/i;
        const latlonRegex = /@-?\d+(\.\d+)?,-?\d+(\.\d+)?/;

        // Prefer explicit Google Maps links
        const mapAnchor = anchors.find(a => mapRegex.test(a.getAttribute('href') || a.href));
        if (mapAnchor) return mapAnchor.getAttribute('href') || mapAnchor.href;

        // Fallback: any link that looks like it contains map coordinates or "maps"/"place"
        const fallback = anchors.find(a => {
            const href = a.getAttribute('href') || a.href || '';
            return /maps|place|direction|@|lat|lon/i.test(href) || latlonRegex.test(href);
        });
        return fallback ? (fallback.getAttribute('href') || fallback.href) : '';
    } catch (err) {
        console.error('Error extracting Google Maps link:', err);
        return '';
    }
};

// Email validation
const isValidEmail = (email) => {
    if (!email) return true; // Email is optional
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

// Form validation
const validateForm = () => {
    let isValid = true;
    
    // Reset errors
    errors.location = '';
    errors.country = '';
    errors.email = '';
    errors.submit = '';

    // Validate location
    if (!formData.location.trim()) {
        errors.location = 'Please enter your preferred location';
        isValid = false;
    }

    // Validate country
    if (!formData.country.trim()) {
        errors.country = 'Please enter your country';
        isValid = false;
    }

    // Validate email if provided
    if (formData.email && !isValidEmail(formData.email)) {
        errors.email = 'Please enter a valid email address';
        isValid = false;
    }

    return isValid;
};

// Submit form
const submitForm = async () => {
    if (!validateForm()) {
        return;
    }

    isSubmitting.value = true;
    errors.submit = '';

    try {
        const response = await $fetch('/api/send-testride-email', {
            method: 'POST',
            body: {
                location: formData.location,
                country: formData.country,
                email: formData.email || 'Not provided'
            }
        });

        if (response.success) {
            formSubmitted.value = true;
            // Clear form data but keep formSubmitted true to show confirmation
            clearFormData();
        } else {
            errors.submit = response.error || 'Failed to send request. Please try again.';
        }
    } catch (error) {
        console.error('Error submitting form:', error);
        errors.submit = 'An error occurred. Please try again later.';
    } finally {
        isSubmitting.value = false;
    }
};

onMounted(async () => {

    try {
        locationsBlog.value = await blogStore.fetchBlogByHandle(props.slug);
        mounted.value = true;
    }
    catch (err) {
        console.error('Error fetching slides data:', err);
    }


});


const slideHeader = computed(() => {
    try {
        //return techBlog.value.articles[0].title;
        return locationsBlog.value.articles[myCarousel.value.data.currentSlide].title;
    } catch (error) {
        return locationsBlog.value.articles[0].title;

    }
});

const locations = computed(() => {
    try {
        const articles = locationsBlog.value?.articles || [];
        return articles.filter(article => {
            const tags = article?.tags;
            if (!tags) return true;
            if (Array.isArray(tags)) {
                return !tags.some(t => String(t).toLowerCase() === 'excluded');
            }
            if (typeof tags === 'string') {
                return !tags.split(',').map(t => t.trim().toLowerCase()).includes('excluded');
            }
            return true;
        });
    } catch (error) {
        return [];
    }
});

const slideContent = computed(() => {
    try {
        //return locationsBlog.value.articles[0].title; ADD ... if texts get longer than 120, now everything fits.
        let content = locationsBlog.value.articles[myCarousel.value.data.currentSlide].content;
        return content.length > 115 ? content.substring(0, 120) + '' : content;

    } catch (error) {
        return locationsBlog.value.articles[0].content;

    }
});


</script>

<style scoped>
.carousel :deep(.carousel__slide) {
    display: block;
}

.carousel :deep(.carousel__next) {
    position: relative;
    transform: none;
    display: block;
    height: 42px;
}

.carousel :deep(.carousel__prev) {
    position: relative;
    transform: none;
    display: block;
    height: 42px;
}

.carousel :deep(.carousel__pagination-item) {
    padding: 5px 3px 10px;
}

.carousel :deep(.carousel__pagination-button) {
    width: 47px;
    height: 6px;
}

.carousel {

    --vc-pgn-width: 25px;
    --vc-pgn-active-color: #ffffff;
    --vc-pgn-background-color: #ffffff66;


}

.carousel__pagination {

    bottom: inherit;
    left: inherit;
    position: relative !important;
    display: flex;
    transform: none;

}
</style>
